(() => {
  // Searching filter options is only a visual lookup; it is not a Shopify filter.
  const inputSelector = '[data-facet-search-input], [data-mobile-facet-search]';
  const savedQueries = new Map();
  const normalise = (value) => String(value || '').trim().toLowerCase();

  const applySearch = (input) => {
    const mobile = input.hasAttribute('data-mobile-facet-search');
    const container = input.closest(mobile ? '.mobile-facets__submenu' : '.facets__display-vertical');
    if (!container) return;

    const items = container.querySelectorAll(
      mobile ? '.mobile-facets__item[data-filter-value]' : '.facets__item[data-filter-value]'
    );
    const query = normalise(input.value);

    items.forEach((item) => {
      const matches = !query || normalise(item.dataset.filterValue).includes(query);

      if (!mobile && item.dataset.facetSearchOriginalHidden == null) {
        // Preserve the normal Show more / Show less state when search is cleared.
        item.dataset.facetSearchOriginalHidden = item.classList.contains('hidden') ? 'true' : 'false';
      }

      item.classList.toggle('facet-search-hidden', Boolean(query) && !matches);
      if (!mobile) {
        item.classList.toggle('hidden', query ? !matches : item.dataset.facetSearchOriginalHidden === 'true');
      }
    });

    if (!mobile) {
      const showMore = container.querySelector('show-more-button');
      if (showMore) showMore.hidden = Boolean(query);
    }
  };

  const onSearchInput = (event) => {
    const input = event.target.closest?.(inputSelector);
    if (!input) return;

    // FacetFiltersForm listens for all form input events and would otherwise
    // send a section-render request while the customer is typing here.
    event.stopPropagation();
    const filterId = input.closest('.js-filter')?.id;
    if (filterId) {
      if (input.value) savedQueries.set(filterId, input.value);
      else savedQueries.delete(filterId);
    }
    applySearch(input);
  };

  document.addEventListener('input', onSearchInput, true);
  document.addEventListener('search', onSearchInput, true);
  document.addEventListener('change', (event) => {
    if (event.target.closest?.(inputSelector)) event.stopPropagation();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.closest?.(inputSelector)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // Shopify replaces facet option lists after a real checkbox change. Keep the
  // lookup text and hide non-matching options again on the freshly rendered list.
  const restoreSearches = () => {
    document.querySelectorAll(inputSelector).forEach((input) => {
      const saved = savedQueries.get(input.closest('.js-filter')?.id);
      if (saved == null) return;
      if (input.value !== saved) input.value = saved;
      applySearch(input);
    });
  };

  const observer = new MutationObserver(() => restoreSearches());
  const observeFilters = () => {
    const container = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
    if (!container) return;
    observer.disconnect();
    observer.observe(container, { childList: true, subtree: true });
    restoreSearches();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeFilters, { once: true });
  } else {
    observeFilters();
  }
  document.addEventListener('shopify:section:load', observeFilters);
})();

